{
  "previous": "前へ",
  "next": "次へ",
  "complete": "完了",
  "verifyAndCheckIn": "確認してチェックイン",
  "loading": {
    "retrievingLocation": "位置情報を取得しています...",
    "retrievingWarehouse": "倉庫データを取得しています..."
  },
  "validation": {
    "fieldRequired": "この項目は必須です",
    "fieldRequiredWithLabel": "{label}は必須です",
    "phoneInvalid": "有効な電話番号ではありません",
    "phoneInvalidWithExample": "有効な電話番号ではありません（例：{example}）"
  }
}
